import { render, staticRenderFns } from "./TeamListView.vue?vue&type=template&id=4bd4aec5&scoped=true"
import script from "./TeamListView.vue?vue&type=script&lang=js"
export * from "./TeamListView.vue?vue&type=script&lang=js"
import style0 from "./TeamListView.vue?vue&type=style&index=0&id=4bd4aec5&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd4aec5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd4aec5')) {
      api.createRecord('4bd4aec5', component.options)
    } else {
      api.reload('4bd4aec5', component.options)
    }
    module.hot.accept("./TeamListView.vue?vue&type=template&id=4bd4aec5&scoped=true", function () {
      api.rerender('4bd4aec5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/teams/TeamListView.vue"
export default component.exports